/* stylelint-disable */
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { withStyledAttrs } from '../../helpers/styled';
import Text from '../Text';
import theme from '../../theme';
var CutOut = withTheme(styled.div.withConfig({
  displayName: "VoucherListViewstyle__CutOut",
  componentId: "sc-8gv0rg-0"
})(function (p) {
  return "\n  width: 2px;\n  height: calc(100% - 16px);\n  margin-top: 8px;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  position: absolute;\n  left: 103px;\n  @media (min-width: ".concat(p.coreTheme.brk_sm, ") {\n    left: 141px;\n  }\n\n  background: radial-gradient(ellipse at center, ").concat(p.backgroundColor || p.coreTheme.cl_white, " 0%, ").concat(p.backgroundColor || p.coreTheme.cl_white, " 30%, transparent 30%);\n  background-size: 5px 5px;\n  background-repeat: repeat-y;\n  background-position: center;\n");
}));
var TagWrapper = styled.div.withConfig({
  displayName: "VoucherListViewstyle__TagWrapper",
  componentId: "sc-8gv0rg-1"
})(["position:absolute;bottom:0;width:100%;"]);
var CouponCover = withTheme(styled.div.withConfig({
  displayName: "VoucherListViewstyle__CouponCover",
  componentId: "sc-8gv0rg-2"
})(["width:104px;height:inherit;border-top-left-radius:8px;border-bottom-left-radius:8px;position:relative;overflow:hidden;@media (min-width:", "){width:142px;}& > img{width:100%;height:auto;}"], theme.breakpoints.sm));
var CouponBody = styled.div.withConfig({
  displayName: "VoucherListViewstyle__CouponBody",
  componentId: "sc-8gv0rg-3"
})(["width:223px;overflow:hidden;height:inherit;display:flex;flex-direction:column;justify-content:center;padding:10px 16px;box-sizing:border-box;border-top-right-radius:8px;border-bottom-right-radius:8px;@media (min-width:", "){width:250px;padding:20.5px 16px;}"], theme.breakpoints.sm);
var Title = withTheme(withStyledAttrs(Text, {
  type: 'boldBody',
  lineHeight: 'compact',
  fontSize: [14, 14, 15, 16, 16]
})(function (p) {
  return "\n  /* stylelint-disable value-no-vendor-prefix */\n  display: -webkit-box;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: ".concat(p.maxLines, ";\n  ");
}));
var SubTitle = withTheme(withStyledAttrs(Text, {
  type: 'smallBody',
  lineHeight: 'compact',
  fontSize: [14, 14, 14, 14, 14]
})(function (p) {
  return "\n  color: ".concat(p.expiring ? p.coreTheme.cl_pri_d3 : p.coreTheme.cl_ter_l2, ";\n");
}));
var Value = withTheme(withStyledAttrs(Text, {
  type: 'smallBody',
  lineHeight: 'compact',
  fontSize: [14, 14, 15, 16, 16]
})(function (p) {
  return "\n  color: ".concat(p.expiring ? p.coreTheme.cl_pri_d3 : p.coreTheme.cl_ter_l2, ";\n");
}));
var ValueWrapper = styled.div.withConfig({
  displayName: "VoucherListViewstyle__ValueWrapper",
  componentId: "sc-8gv0rg-4"
})(["margin-top:4px;display:flex;align-items:center;svg{margin-right:4px;width:16px;height:16px;@media (min-width:", "){width:24px;height:24px;}}"], theme.breakpoints.sm);
var Container = withTheme(styled.div.withConfig({
  displayName: "VoucherListViewstyle__Container",
  componentId: "sc-8gv0rg-5"
})(function (p) {
  return css(["background-color:inherit;display:flex;width:max-content;height:104px;box-shadow:", ";box-sizing:border-box;border-radius:8px;position:relative;@media (min-width:", "){height:142px;}&::before,::after{content:'';position:absolute;left:96px;width:16px;height:16px;background-color:", ";z-index:1;@media (min-width:", "){left:134px;}", "}&::before{border-bottom-left-radius:25px;border-bottom-right-radius:25px;top:-8px;box-shadow:0 -1px 2px -1px rgba(0 0 0 / 20%) inset;}&::after{border-top-left-radius:25px;border-top-right-radius:25px;bottom:-8px;box-shadow:-2px 6px 2px -5px rgba(0 0 0 / 20%) inset;}", ""], p.coreTheme.sd_size_1, p.coreTheme.brk_sm, p.coreTheme.cl_white, p.coreTheme.brk_sm, p.curveStyle && p.curveStyle, p.disabled && "\n    box-shadow: none;\n\n    &::before,::after {\n      box-shadow: none;\n    }\n\n    svg {\n      path {\n        fill: ".concat(p.coreTheme.cl_ter_l2, "\n      }\n    }\n\n    ").concat(CouponBody, " {\n      background-color: ").concat(p.coreTheme.cl_ter_l5, ";\n    }\n  "));
}));
export { Container, CouponCover, CouponBody, TagWrapper, Title, SubTitle, ValueWrapper, Value, CutOut };